<div class="wrap-search-bar">
    <div class="container">
        <div class="search-bar d-flex justify-content-between align-items-center">
            <div class="wrap-input">
                <label class="mb-0" for="">{{
                    'IRONSIDE.product-list.search-product' | translate
                }}</label>
                <input
                    (focusout)="emptyList()"
                    (keyup)="onSearchInput()"
                    (keydown.enter)="redirectToSearchPage()"
                    [(ngModel)]="searchValue"
                    type="text"
                    [placeholder]="'IRONSIDE.global-search-on-the-catalog' | translate"
                />

                <div class="autocomplete-list" *ngIf="autocompleteSearchListProducts.length > 0">
                    <ul class="p-0" style="list-style: none">
                        <li
                            class="ac-li"
                            *ngFor="let item of autocompleteSearchListProducts"
                            (click)="selectItem(item)"
                        >
                            {{
                                item.shortDescription
                                    ? item.referenceProduct +
                                      ' - ' +
                                      (item.shortDescription | translateDynamicLanguage) +
                                      (item.brand ? ' - ' + item.brand.fr_FR : '')
                                    : ''
                            }}
                        </li>
                    </ul>
                </div>
            </div>
            <button (click)="redirectToSearchPage()" class="btn-common btn-search">
                <span class="btn-search-text">
                    {{ 'IRONSIDE.product-list.search' | translate }}
                </span>
                <span class="pi pi-search"></span>
            </button>
        </div>
    </div>
</div>
